import React from 'react';
import List from './List';
const Quotes = ({clientId, ...props}) => {
    return (
        <List typeId={1}  clientId={clientId} {...props}/>
    );
}

export default Quotes;
